<div class="lead-page">
  <div class="lead-shell">
    <div class="lead-header">
      <div class="lead-title">
        <h2>{{ isEdit ? 'Edit Sales & Installation Partner' : 'Add Sales & Installation Partner' }}</h2>
        <p>Keep this profile lightweight and tie it into leads and organizations.</p>
      </div>
      <div class="lead-actions">
        <button class="lead-btn-muted" (click)="router.navigate(['admin/sales-installation-partners'])">Back to List</button>
      </div>
    </div>

    <div class="lead-section">
      <h4>Basic Details</h4>
      <div class="lead-form-grid">
        <div class="lead-form-field"><label>Company Name *</label><input [(ngModel)]="model.company_name" /></div>
        <div class="lead-form-field"><label>Contact Person</label><input [(ngModel)]="model.contact_person" /></div>
        <div class="lead-form-field"><label>Mobile Number *</label><input [(ngModel)]="model.mobile_number" /></div>
        <div class="lead-form-field"><label>Alternate Mobile Number</label><input [(ngModel)]="model.alternate_mobile_number" /></div>
        <div class="lead-form-field"><label>Email</label><input [(ngModel)]="model.email" /></div>
        <div class="lead-form-field"><label>City</label><input [(ngModel)]="model.city" /></div>
        <div class="lead-form-field"><label>State</label><input [(ngModel)]="model.state" /></div>
        <div class="lead-form-field"><label>GST Number</label><input [(ngModel)]="model.gst_number" /></div>
        <div class="lead-form-field"><label>Business Type</label><select [(ngModel)]="model.business_type"><option value="">Select</option><option *ngFor="let option of businessTypes" [value]="option[0]">{{ option[1] }}</option></select></div>
        <div class="lead-form-field"><label>Status *</label><select [(ngModel)]="model.status"><option *ngFor="let option of statuses" [value]="option[0]">{{ option[1] }}</option></select></div>
        <div class="lead-form-field" style="grid-column: 1 / -1;"><label>Address</label><textarea [(ngModel)]="model.address"></textarea></div>
        <div class="lead-form-field" style="grid-column: 1 / -1;"><label>Service Areas</label><textarea [(ngModel)]="model.service_areas"></textarea></div>
      </div>
    </div>

    <div class="lead-section">
      <h4>Commercial Details</h4>
      <div class="lead-form-grid">
        <div class="lead-form-field"><label>Default Commission Type</label><select [(ngModel)]="model.default_commission_type"><option value="">Select</option><option *ngFor="let option of commissionTypes" [value]="option[0]">{{ option[1] }}</option></select></div>
        <div class="lead-form-field"><label>Default Commission Value</label><input type="number" [(ngModel)]="model.default_commission_value" /></div>
        <div class="lead-form-field"><label>Default Margin Percentage</label><input type="number" [(ngModel)]="model.default_margin_percentage" /></div>
      </div>
    </div>

    <div class="lead-section">
      <h4>Notes</h4>
      <div class="lead-form-field"><label>Notes</label><textarea [(ngModel)]="model.notes"></textarea></div>
    </div>

    <div class="inline-actions">
      <button class="lead-btn" (click)="save()" [disabled]="saving || !model.company_name || !model.mobile_number || !model.status">
        {{ saving ? 'Saving...' : (isEdit ? 'Update Partner' : 'Create Partner') }}
      </button>
      <button class="lead-btn-muted" (click)="router.navigate(['admin/sales-installation-partners'])">Cancel</button>
    </div>
  </div>
</div>
